export default {
	SET_UNIT_NAMES: "SET_UNIT_NAMES",
	SET_LOADING: "SET_LOADING"
}